import React from 'react';

/**
 * Virgy · the small squirrel mark. Used as a calm logo at ~32px; no idle
 * animations. Optional gentle tail wag triggered only on hover (small).
 */
export default function VirgyMascot({ size = 32, className = '' }) {
  return (
    <svg
      viewBox="0 0 240 240"
      width={size}
      height={size}
      className={`virgy-mascot ${className}`}
      role="img"
      aria-label="Virgy"
    >
      <style>{`
        .virgy-mascot .v-tail { transform-origin: 165px 140px; transition: transform .4s ease; }
        .virgy-mascot:hover .v-tail { transform: rotate(6deg); }
      `}</style>

      {/* tail */}
      <g className="v-tail">
        <path
          d="M 168 158 C 210 150, 222 110, 198 78
             C 222 100, 220 60, 188 56
             C 200 70, 184 76, 178 92
             C 168 116, 152 138, 158 162 Z"
          fill="hsl(28, 28%, 38%)" stroke="hsl(var(--text))" strokeWidth="3" strokeLinejoin="round"
        />
      </g>

      {/* body */}
      <path
        d="M 92 142 C 70 150, 64 188, 92 200 L 150 200 C 178 188, 174 150, 152 142 Z"
        fill="hsl(28, 42%, 56%)" stroke="hsl(var(--text))" strokeWidth="3" strokeLinejoin="round"
      />
      <path
        d="M 102 158 C 96 178, 110 198, 122 198 C 138 198, 152 180, 146 158 Z"
        fill="hsl(40, 55%, 90%)" stroke="hsl(var(--text))" strokeWidth="2"
      />

      {/* head */}
      <ellipse cx="120" cy="100" rx="44" ry="42" fill="hsl(28, 42%, 56%)" stroke="hsl(var(--text))" strokeWidth="3" />
      <path d="M 80 108 Q 96 116, 110 108" fill="hsl(40, 55%, 90%)" stroke="hsl(var(--text))" strokeWidth="2" />

      {/* ears */}
      <path d="M 88 70 Q 92 50, 104 64 Q 100 78, 88 78 Z" fill="hsl(28, 42%, 56%)" stroke="hsl(var(--text))" strokeWidth="2.5" />
      <path d="M 152 70 Q 148 50, 136 64 Q 140 78, 152 78 Z" fill="hsl(28, 42%, 56%)" stroke="hsl(var(--text))" strokeWidth="2.5" />

      {/* eyes */}
      <circle cx="104" cy="98" r="5" fill="hsl(var(--text))" />
      <circle cx="136" cy="98" r="5" fill="hsl(var(--text))" />

      {/* nose + smile */}
      <path d="M 120 110 q -4 4, 0 6 q 4 -2, 0 -6 Z" fill="hsl(var(--text))" />
      <path d="M 116 120 q 4 4, 8 0" fill="none" stroke="hsl(var(--text))" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
